import React from 'react';
import Splash_ESignup from '../commons/splash_esignup';
import MenuComponent from '../commons/menu';

import {IndexLink, Link, withRouter} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

class ESignUpPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        if (isMobile) {
            return (
                <div id={"response-home-mobile"}>
                    <div className={"block-001"}>
                        <Link to="/"><img className={"img_logo"} src="/static/img/homeimg/m_versity_logo.png"/></Link>
                    </div>
                    <div className={"block-002"}>
                        <Splash_ESignup
                            isMobile={1}
                            openDialog={this.props.openDialog}
                            url="/code/apis.php"
                        />
                    </div>
                </div>
            )
        }
        return (
            <div className="account_box account_signin">
                <div className="login_btn">
                    <Link to="/"><img src="/static/img/homeimg/versity_logo.png"/></Link>
                    <Link className="btn_login" to="/signin">Log in</Link>
                </div>
                <div className={"account_box_background account_employer"}>
                    <div className="account_box_wrapper">
                        <img className={"top-image"} src="/static/img/homeimg/hd.png"/>
                        <Splash_ESignup openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </div>
                <div className="account_box_footer">
                    <p><span>Copyright</span> ® 2025, Versity, Inc. "Versity" and logo are proprietary trademarks of Versity, Inc.</p>
                    <p><Link to="/terms">Terms of Use</Link> | <Link to="/privacy">Privacy</Link> & <Link to="/cookies">Cookies</Link></p>
                </div>
            </div>
        )
    }
}
ESignUpPage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(ESignUpPage));



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/esignup.js
 **/